export default {
    getCandles: ({candles}) => candles,
    gettrades: ({trades}) => trades,
    getCoins: ({coins}) => coins,
  };